module.exports = __webpack_public_path__ + "images/app.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.png
// module id = 956
// module chunks = 2